import { useEffect, useRef, useState } from "react";
import { CaretDown, Check } from "@phosphor-icons/react";

/**
 * Dropdown de selección múltiple con checkboxes.
 * options: string[]  ·  selected: string[]  ·  onToggle(value)
 */
export function MultiSelect({ options = [], selected = [], onToggle, placeholder = "Selecciona", testid = "multiselect", disabled = false }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const sel = selected || [];
  const label = sel.length === 0 ? placeholder : sel.length === 1 ? sel[0] : `${sel.length} seleccionadas`;

  return (
    <div className="relative" ref={ref}>
      <button type="button" data-testid={testid} disabled={disabled} onClick={() => setOpen(!open)}
        className="w-full min-h-[3rem] px-4 py-2.5 rounded-xl border border-zinc-300 bg-white flex items-center justify-between gap-2 text-left focus:outline-none focus:ring-2 focus:ring-[#FF5A36] disabled:opacity-50 disabled:cursor-not-allowed">
        <span className={`text-sm truncate ${sel.length ? "text-[#0F1115] font-medium" : "text-zinc-400"}`}>{label}</span>
        <CaretDown size={16} className={`text-zinc-400 shrink-0 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute z-40 mt-1 w-full max-h-64 overflow-auto bg-white rounded-xl border border-zinc-200 shadow-xl" data-testid={`${testid}-panel`}>
          {options.length === 0 && <div className="px-4 py-3 text-sm text-zinc-400">Sin opciones disponibles</div>}
          {options.map((o) => {
            const active = sel.includes(o);
            return (
              <button key={o} type="button" onClick={() => onToggle(o)} data-testid={`${testid}-option-${o}`}
                className="w-full text-left px-4 py-2.5 text-sm hover:bg-zinc-50 flex items-center gap-2.5 border-b border-zinc-50 last:border-0">
                <span className={`w-4 h-4 rounded border flex items-center justify-center shrink-0 ${active ? "bg-[#FF5A36] border-[#FF5A36]" : "border-zinc-300"}`}>
                  {active && <Check size={12} weight="bold" className="text-white" />}
                </span>
                <span className={active ? "font-medium text-[#0F1115]" : "text-zinc-700"}>{o}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
